@if (value <= scores[0]) {
  <div class="low" [nbTooltip]="('score' | translate) + ': ' + (value * 100).toFixed(0)" nbTooltipStatus="danger">
    <span class="half"></span>
    <span></span>
    <span></span>
  </div>
}
@if (value > scores[0] && value <= scores[1]) {
  <div class="low" [nbTooltip]="('score' | translate) + ': ' + (value * 100).toFixed(0)" nbTooltipStatus="danger">
    <span class="whole"></span>
    <span></span>
    <span></span>
  </div>
}
@if (value > scores[1] && value <= scores[2]) {
  <div class="med" [nbTooltip]="('score' | translate) + ': ' + (value * 100).toFixed(0)" nbTooltipStatus="warning">
    <span class="whole"></span>
    <span class="half"></span>
    <span></span>
  </div>
}
@if (value > scores[2] && value <= scores[3]) {
  <div class="med" [nbTooltip]="('score' | translate) + ': ' + (value * 100).toFixed(0)" nbTooltipStatus="warning">
    <span class="whole"></span>
    <span class="whole"></span>
    <span></span>
  </div>
}
@if (value > scores[3] && value <= scores[4]) {
  <div class="high" [nbTooltip]="('score' | translate) + ': ' + (value * 100).toFixed(0)" nbTooltipStatus="success">
    <span class="whole"></span>
    <span class="whole"></span>
    <span class="half"></span>
  </div>
}
@if (value > scores[4]) {
  <div class="high" [nbTooltip]="('score' | translate) + ': ' + (value * 100).toFixed(0)" nbTooltipStatus="success">
    <span class="whole"></span>
    <span class="whole"></span>
    <span class="whole"></span>
  </div>
}
